import Guard from "vue-router-multiguard";
import { Middlewares } from "@/app/shared/services/app-router/middlewares";

export default [
    {
        path: "/notification-settings",
        name: "NotificationSettings",
        component: () => import("./views/chain"),
        beforeEnter: Guard([Middlewares.authRequired, Middlewares.adminAccess]),
    },
    {
        path: "/instant-notifications",
        name: "InstantNotifications",
        component: () => import("./views/instant"),
        beforeEnter: Guard([Middlewares.authRequired, Middlewares.adminAccess]),
    },
    {
        path: "/notification-statistics",
        name: "NotificationStatistics",
        component: () => import("./views/statistics"),
        beforeEnter: Guard([Middlewares.authRequired, Middlewares.adminAccess]),
    },
];
